import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

async function assertAdmin(supabase: any, userId: string) {
  const { data } = await supabase.from("user_roles").select("role").eq("user_id", userId);
  const roles = (data ?? []).map((r: { role: string }) => r.role);
  if (!roles.includes("admin")) throw new Error("Forbidden: admin only");
}

export const listAdminPaymentInstructions = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    await assertAdmin(context.supabase, context.userId);
    const { data, error } = await context.supabase
      .from("payment_instructions")
      .select("*")
      .order("sort_order", { ascending: true });
    if (error) throw error;
    return data ?? [];
  });

const upsertInput = z.object({
  id: z.string().uuid().optional(),
  region_slug: z.string().min(2),
  title_ar: z.string().min(1),
  body_md: z.string().min(1),
  is_active: z.boolean().default(true),
  sort_order: z.number().int().default(0),
});

export const upsertPaymentInstruction = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .validator((d: unknown) => upsertInput.parse(d))
  .handler(async ({ context, data }) => {
    await assertAdmin(context.supabase, context.userId);
    const { id, ...patch } = data;
    if (id) {
      const { error } = await context.supabase.from("payment_instructions").update(patch).eq("id", id);
      if (error) throw error;
      return { id };
    }
    const { data: row, error } = await context.supabase
      .from("payment_instructions")
      .upsert(patch, { onConflict: "region_slug" })
      .select("id")
      .single();
    if (error) throw error;
    return { id: row.id };
  });